import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-point" }
const _hoisted_2 = { class: "as-player" }
const _hoisted_3 = { class: "as-player-detail" }
const _hoisted_4 = { class: "as-player-point" }

import { computed } from "vue";
import type { IPlayer } from "~src/interfaces/basketball";


const __default__ = {};

interface IProps {
  player: IPlayer | any;
  playerName: string;
  point: number;
  type: string;
  pointHomeMatch: number[];
  pointAwayMatch: number[];
  indexCurrentScore: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentPlayer',
  props: {
    player: {},
    playerName: {},
    point: {},
    type: { default: 'home' },
    pointHomeMatch: {},
    pointAwayMatch: {},
    indexCurrentScore: {}
  },
  setup(__props: any) {

const props = __props;
const scoreData = computed(() => {
  let pointHome = 0;
  let pointAway = 0;
  for (let i = 0; i < props.indexCurrentScore; i++) {
    pointHome += props.pointHomeMatch[i];
  }
  for (let i = 0; i < props.indexCurrentScore; i++) {
    pointAway += props.pointAwayMatch[i];
  }
  return {
    homeScore: pointHome,
    awayScore: pointAway
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('as-incident-player as-' + _ctx.type)
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.point), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.player.homeScore) + " - " + _toDisplayString(props.player.awayScore), 1)
      ])
    ])
  ], 2))
}
}

})